import { get, post, put } from "./api";

export const getUserProfile = () => get("/profile");
export const getRoutes = () => get("/routes");
export const createRoute = (data) => post("/routes", data);
export const updateRoute = (id, data) => put("/routes/" + id, data);